import { render, staticRenderFns } from "./formDetall.vue?vue&type=template&id=0c32d829&scoped=true&"
import script from "./formDetall.vue?vue&type=script&lang=js&"
export * from "./formDetall.vue?vue&type=script&lang=js&"
import style0 from "./formDetall.vue?vue&type=style&index=0&id=0c32d829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32d829",
  null
  
)

export default component.exports